var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDayOfMonth = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M8.6 6c.22 0 .4.18.4.4v.933h5.667V6.4a.4.4 0 0 1 .8 0v.933H16.5a1.5 1.5 0 0 1 1.5 1.5V10h-.005a1 1 0 0 1 .005.083V16.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-6.417q0-.042.005-.083H6V8.833a1.5 1.5 0 0 1 1.5-1.5h.7V6.4c0-.22.18-.4.4-.4M6.9 16.5v-6.267h10.2V16.5a.6.6 0 0 1-.6.6h-9a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M11.83 14.02a6 6 0 0 1 .18.408l.088-.212q.044-.105.095-.201l1.284-2.404a.4.4 0 0 1 .048-.072.2.2 0 0 1 .057-.038.3.3 0 0 1 .072-.015 1 1 0 0 1 .094-.004h.609v4.338h-.711v-2.802q0-.078.002-.17l.016-.19-1.312 2.46a.36.36 0 0 1-.117.133.3.3 0 0 1-.167.045h-.111a.3.3 0 0 1-.168-.045.36.36 0 0 1-.117-.133l-1.33-2.469q.012.1.015.196.007.092.007.173v2.802h-.712v-4.338h.61q.053 0 .092.004a.2.2 0 0 1 .07.014.2.2 0 0 1 .06.04.3.3 0 0 1 .05.072l1.296 2.409Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDayOfMonth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/day-of-month.3f5589c8.svg";